import type {
  DocState,
  DocumentBook,
  DocumentData,
  DocumentNode,
} from '@worldathletics/types';
import { Guid } from 'guid-typescript';

import { BrandColors } from '@/lib/brand-colors';

export const StatusToDisplayLabel = {
  DRAFT: 'Draft',
  REVIEW: 'Pending Review',
  SCHEDULED: 'Scheduled',
  PUBLISHED: 'Published',
  ARCHIVED: 'Archived',
  DELETED: 'Deleted',
} satisfies Record<DocState, string>;

export const StatusToColor = {
  DRAFT: { background: '#E9E9E9', color: '#1E1E1E' },
  REVIEW: { background: BrandColors.turquoise[500], color: '#1E1E1E' },
  SCHEDULED: { background: '#D4EDFF', color: '#1E1E1E' },
  PUBLISHED: { background: BrandColors.green[500], color: '#1E1E1E' },
  ARCHIVED: { background: '#FFAAAA', color: '#1E1E1E' },
  DELETED: { background: '#1E1E1E', color: '#FFFFFF' },
} satisfies Record<DocState, { background: string; color: string }>;

export const DOCUMENT_FILTER_LABELS: { [key: string]: string } = {
  recent: 'Recently added',
  lostLinks: 'Lost links',
  published: 'Published',
  drafts: 'Drafts',
};

export const CONTEXT_DEFAULT_VALUES_BOOK: DocumentBook = {
  id: Guid.create().toString(),
  name: '',
  state: 'DRAFT',
  kind: 'standard',
  dateModified: new Date().toDateString(),
  datePublished: '',
  versions: 0,
  references: 0,
  author: null,
  createdAt: new Date().toDateString(),
  updatedAt: new Date().toDateString(),
};

export const CONTEXT_DEFAULT_VALUES_NODE: DocumentNode = {
  id: Guid.create().toString(),
  bookId: '',
  version: 1,
  language: 'EN',
  state: 'DRAFT',
  contributors: [],
  blocks: [],
  createdAt: new Date().toDateString(),
  updatedAt: new Date().toDateString(),
  numberingStyle: 'numeric',
};

export const CONTEXT_DEFAULT_VALUES_DATA: DocumentData[] = [
  {
    id: Guid.create().toString(),
    type: 'container',
    style: 'part',
    order: 1,
    title: 'Part',
    blocks: [],
  },
];

export const NUMBERING_STYLE_OPTIONS = [
  { label: 'None (no number)', value: 'none' },
  { label: 'Free (manual)', value: 'free' },
  { label: 'Numeric', value: 'numeric' },
  { label: 'Alpha lower', value: 'alpha_lower' },
  { label: 'Alpha upper', value: 'alpha_upper' },
  { label: 'Roman lower', value: 'roman_lower' },
  { label: 'Roman upper', value: 'roman_upper' },
];

export const NUMBERING_STYLE_POSITION_OPTIONS = [
  { label: 'Suffix (Part I)', value: 'suffix' },
  { label: 'Prefix (I Part)', value: 'prefix' },
];
